import React from 'react';
import { Box, Typography, Link, IconButton, useMediaQuery } from '@mui/material';
import { FaInstagram, FaLinkedin, FaYoutube, FaFacebook, FaPhone, FaMapMarkerAlt, FaEnvelope } from 'react-icons/fa';
import { useLocation } from 'react-router-dom';
import getEmail from '../../functions/getEmail';
import { formatPhoneNumber } from '../../functions/formatPhone';

import selo_innova_ans from "../../assets/icons/selo-innova-ans.png";
import ans_logo from "../../assets/icons/ans-logo.png";
import config from '../../config';

const Footer = () => {

  const location = useLocation();

  const isMobile = useMediaQuery("(max-width:768px)");
  
  // const linkLinkedin = `https://www.linkedin.com${process.env.REACT_APP_LINKEDIN}`;
  // const linkInstagram = `https://www.instagram.com/${process.env.REACT_APP_INSTAGRAM}`;
  // const linkFacebook = `https://www.facebook.com/${process.env.REACT_APP_FACEBOOK}`;
  // const linkYoutube = `https://www.youtube.com/@${process.env.REACT_APP_YOUTUBE}`;
  
  const linkLinkedin = `https://www.linkedin.com${config.REACT_APP_LINKEDIN}`;
  const linkInstagram = `https://www.instagram.com/${config.REACT_APP_INSTAGRAM}`;
  const linkFacebook = `https://www.facebook.com/${config.REACT_APP_FACEBOOK}`;
  const linkYoutube = `https://www.youtube.com/@${config.REACT_APP_YOUTUBE}`;

  const path = location.pathname;

  // const telefoneOuvidoria = process.env.REACT_APP_FALE_OUVIDORIA;
  // const telefoneFaleConosco = process.env.REACT_APP_FALE_CONOSCO;
  // const endereco = process.env.REACT_APP_FALE_ENDERECO;

  const telefoneOuvidoria = config.REACT_APP_FALE_OUVIDORIA;
  const telefoneFaleConosco = config.REACT_APP_FALE_CONOSCO;
  const endereco = config.REACT_APP_FALE_ENDERECO;

  const styleContainer: React.CSSProperties = {
    // backgroundImage: `url(${textura})`,
    // backgroundSize: "repeat",
    // backgroundPosition: "center",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "20px",
    color: "#333",
    paddingLeft: path === "/beneficiario" ? "300px" : "0"
  };

  const styleLinks: React.CSSProperties = {
    display: "flex",
    flexDirection: isMobile ? "row" : "column",
    justifyContent: "center",
    alignItems: "center",
    gap: "1em"
  };

  const styleSocialIcons: React.CSSProperties = {
    display: "flex",
    gap: "12px",
    marginTop: "10px"
  };

  const colorIcon = "#004387";
  const colorText = "#7e7e7e";

  const styleFlex: React.CSSProperties = {
    display: "flex",
    alignItems: "center",
    gap: "0.5em"
  }

  return (
    <Box component="footer" style={styleContainer}>
      <Box 
        display="flex" 
        justifyContent="space-between"
        flexDirection={ isMobile ? "column" : "row"}
        width="100%" 
        maxWidth="1376px" 
        padding="20px"
      >
        {/* Informações de Contato */}
        <Box sx={{ display: "flex", flexDirection: "column", gap: "0.5em"}}>
            <Typography variant="body1" fontWeight={600}>Fale conosco</Typography>
            <Box sx={styleFlex}>
            <FaMapMarkerAlt color={colorIcon} />
            <Typography 
                variant="body2"
                textAlign="justify"
                component="a" 
                href="https://www.google.com/maps/search/?api=1&query=Av.+Abuna,+2250,+Sao+Joao.+Bosco,+Porto+Velho-RO" 
                target="_blank" 
                rel="noopener noreferrer" 
                sx={{ textDecoration: 'none', color: 'inherit' }} // opcional, para estilizar
            >
                {endereco}
            </Typography>
        </Box>

            <Box sx={styleFlex}>
                <FaPhone color={colorIcon} />
                <Typography variant="body2">
                    {formatPhoneNumber(telefoneFaleConosco)}
                </Typography>

            </Box>
            <Box sx={styleFlex}>
                <FaEnvelope color={colorIcon} />
                <Typography 
                    variant="body2" 
                    component="a" 
                    href="mailto:innovaplanodesaude@gmail.com" 
                    sx={{ textDecoration: 'none', color: 'inherit' }} // opcional, para estilizar
                >
                  {getEmail()}
                </Typography>
            </Box>

          
          <Typography variant="body2" fontWeight="bold">
            OUVIDORIA
          </Typography>
          <Box display="flex" gap={1}>
            <FaPhone color={colorIcon} /> 
            <Typography variant="body2">
              {formatPhoneNumber(telefoneOuvidoria)}
            </Typography>

          </Box>
        </Box>

        {/* Links Úteis */}

        <Box style={styleLinks}>
          <img 
            src={ans_logo} 
            alt="Logo ANS"
            width="100px"
          />

          <img 
            src={selo_innova_ans} 
            alt="Selo Innova ANS"
            width="120px"
          />

        </Box>

        {/* Redes Sociais */}
        <Box>
          <Typography variant="body1" fontWeight={600}  textAlign={ isMobile ? "left" : "center"}>Siga-nos</Typography>
          <Box style={styleSocialIcons} component="div" className='box-sociais'>
            <Link href={linkInstagram} color="inherit" target="_blank"><IconButton><FaInstagram color={colorIcon} size={24} /></IconButton></Link>
            <Link href={linkLinkedin} color="inherit" target="_blank"><IconButton><FaLinkedin color={colorIcon} size={24} /></IconButton></Link>
            <Link href={linkYoutube} color="inherit" target="_blank"><IconButton><FaYoutube color={colorIcon} size={24} /></IconButton></Link>
            <Link href={linkFacebook} color="inherit" target="_blank"><IconButton><FaFacebook color={colorIcon} size={24} /></IconButton></Link>
          </Box>
        </Box>
      </Box>

      {/* Informações de direitos reservados */}
      <Link href={"/politicas-de-privacidade-e-lgpd"} color="inherit" target="_blank">Política de Privacidade</Link>
      <Typography textAlign="center" marginTop="20px">INNOVA PLANO DE SAÚDE | 2024</Typography>
      <Typography textAlign="center">© Todos os direitos reservados</Typography>
    </Box>
  );
};

export default Footer;
